module.exports = __webpack_public_path__ + "static/media/15.7ada0c12.jpeg";